export default "__VITE_ASSET__Dipn_Oi4__"